import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { yelValidate } from '../../containers/validate'
import { useForm, Form, Field, WatchField } from '../../form'
import { useTranslation } from 'react-i18next'
import YelSelect from './yelSelect.component'

class Yel extends React.Component {
  componentDidMount() {
    this.props.getUserYelInfo()
  }

  render() {
    return <YelComponent {...this.props} />
  }
}

const styles = (theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  select: {
    marginTop: theme.spacing(3),
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray',
    width: '100%'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    width: '100%'
  },
  inputContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  incomeInput: {
    verticalAlign: 'bottom',
    width: '45%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  ageInput: {
    alignSelf: 'flex-end',
    width: '45%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: 'bold',
    marginLeft: '15px',
    color: '#808080'
  },
  radioButton: {
    marginTop: theme.spacing(1),
    fontSize: '15px',
    fontWeight: 'bold',
    marginLeft: '15px',
    color: '#808080',
    '&.Mui-checked.Mui-disabled svg': {
      fill: 'rgba(0, 0, 0, 0.38)!important'
    }
  },
  container: {
    maxWidth: '650px',
    margin: '0 auto',
    padding: theme.spacing(2)
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '200px',
    [theme.breakpoints.down('xs')]: {
      width: '50px'
    }
  },
  tooltipContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '10px'
  },
  tooltipRow: {
    display: 'flex',
    alignItems: 'center'
  },
  tooltipWrapper: {
    marginLeft: '8px'
  }
})

const defaultValues = {
  yelSelect: 'no_yel',
  firsttime_enterprenuer: false,
  yel_income: '',
  age_group: ''
}

const YelComponent = ({
  isYelIncomeLock,
  isYelSelectionLock,
  postYelStart,
  invalid,
  submitFailed,
  showYelSnackbar,
  closeYelSnackbar,
  classes,
  userType,
  selectedUser
}) => {
  const form = useForm({
    name: 'yel',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: yelValidate,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    postYelStart(values)
  }

  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <Form {...form}>
        <div className="container-fluid">
          <div>
            <div className="dashboard-content-header">
              <h1 style={{margin: '0px 0px 10px 0px'}}>{t('yelComponent.div')}</h1>
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <YelSelect
                  isYelSelectionLock={isYelSelectionLock}
                  form={form}
                  options={[
                    { value: 'no_yel', label: t('yelComponent.labelNew'), tooltip: t('yelComponent.tooltip1') },
                    { value: 'yel_self', label: t('yelComponent.label'), tooltip: t('yelComponent.tooltip2') },
                    { value: 'yel_recommended', label: t('yelComponent.label2'), tooltip: t('yelComponent.tooltip3') },
                    { value: 'yel_minimum', label: t('yelComponent.label3'), tooltip: t('yelComponent.tooltip4') }
                  ]}
                />
                <WatchField control={control} fields="yelSelect">
                  {(watch) =>
                    watch.yelSelect !== 'yel_recommended' &&
                    watch.yelSelect !== 'yel_minimum' ? null : (
                      <div>
                        <Field
                          name="firsttime_enterprenuer"
                          label={t('yelComponent.label4')}
                          inputType="checkbox"
                          control={control}
                          className={classes.checkbox}
                        />
                        <div className={classes.inputContainer}>
                          <div className={classes.incomeInput}>
                            <Field
                              label={t('yelComponent.label5')}
                              labelStyle={{
                                whiteSpace: 'nowrap'
                              }}
                              name="yel_income"
                              inputType="textfield"
                              control={control}
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                              disabled={isYelIncomeLock}
                            />
                          </div>
                          <div className={classes.ageInput}>
                            <Field
                              name="age_group"
                              inputType="select"
                              control={control}
                              label={t('yelComponent.text')}
                              className={classes.select}
                            >
                              <MenuItem key={1} value={'18-52 vuotias'}>
                                {t('yelComponent.text2')}
                              </MenuItem>
                              <MenuItem key={2} value={'53-62 vuotias'}>
                                {t('yelComponent.text3')}
                              </MenuItem>
                              <MenuItem key={3} value={'63-67 vuotias'}>
                                {t('yelComponent.text4')}
                              </MenuItem>
                            </Field>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </WatchField>
                <div className={classes.buttonContainer}>
                  <Button
                    variant="contained"
                    className={classes.button}
                    disabled={
                      userType === 2 && selectedUser.email === undefined
                    }
                    type="submit"
                  >
                    {t('yelComponent.label6')}
                  </Button>
                </div>
                <div className="panel-body" style={{ fontWeight: 600 }}>
                  <p className="dashboard-tax-description">
                    {t('yelComponent.yelInfoLabel')}
                  </p>
                  <p className="dashboard-tax-address">
                    {t('yelComponent.yelInfo')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={showYelSnackbar}
        autoHideDuration={2000}
        onClose={() => {
          closeYelSnackbar()
        }}
      >
        <MySnackbarContentWrapper
          onClose={() => {
            closeYelSnackbar()
          }}
          variant="success"
          message={t('yelComponent.msg')}
        />
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        open={submitFailed && invalid}
        autoHideDuration={4000}
      >
        <MySnackbarContentWrapper
          variant="error"
          message={t('yelComponent.msg2')}
        />
      </Snackbar>
    </div>
  )
}

Yel.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Yel)
